import tippy, { type Content, type Placement } from 'tippy.js';

interface TooltipSettingsProps {
    content: Content;
    placement?: Placement;
}

interface TooltipProps {
    el: HTMLElement;
    props: TooltipSettingsProps;
}


const Tooltip = ({ el, props }: TooltipProps): void => {
    const { content, placement = 'top' } = props;
    tippy(el, {
        arrow: true,
        content,
        placement,
        appendTo: el,
        theme: 'nebula',
    });
};

export default Tooltip;
